import React from 'react'
import { Field } from 'redux-form'
import { Flag, CurrencyInput, FormLabel, requiredField } from '@offerzen/pinata-shame'

import styles from './styles'

const validators = {
  required: requiredField('Required'),
}

const PreferredSalaryNL = ({ showField, validateField }) => (
  <If condition={showField}>
    <div className={styles.countryFlagWrapper}>
      <Flag countryCode="eu" className={styles.flag} />
      <FormLabel label="&nbsp;EU: Preferred gross annual salary" htmlFor="preferred-salary-nl" />
    </div>
    <Field
      name="netherlands_preferred_annual_salary"
      id="preferred-salary-nl"
      className={styles.currencyInput}
      placeholder="Enter an annual salary"
      validate={validateField ? validators.required : null}
      theme="primary"
      currency="euro"
      component={CurrencyInput}
    />
  </If>
)

export default PreferredSalaryNL
